import DiscourseRoute from 'discourse/routes/discourse';

// Thin route: the public benchmarks listing's fetching/filtering lives in
// ProxyviewsBenchmarksController.loadBenchmarks so filter changes re-fetch
// without re-running the model hook. The route just kicks off the initial
// load and provides the title token.
export default class ProxyviewsBenchmarksRoute extends DiscourseRoute {
  setupController(controller, model) {
    super.setupController(controller, model);
    controller.loadBenchmarks();
  }

  titleToken() {
    return 'Proxy Benchmarks';
  }
}
